module.exports = __webpack_public_path__ + "img/201612-1.05a32977.jpg";